export default __webpack_public_path__ + "static/media/no-stop-agency.5220c3c1.svg";